import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { ProcessInstanceFilterParameterDialog } from "../Ui/Dialogs/ProcessInstanceFilterParameterDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceFilterPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceFilterProperties = {
    [name in keyof EntityCommandProcessInstanceFilterPropertyValues]: Property<EntityCommandProcessInstanceFilterPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceFilter extends IEntityCommand, EntityCommandProcessInstanceFilterProperties
{
}

export class EntityCommandProcessInstanceFilter extends EntityCommand implements IEntityCommandProcessInstanceFilter
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceFilter";
    public static override className = "EntityCommandProcessInstanceFilter";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceFilterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Filter",
                entityName: "ProcessInstance",
                key: "FILTER",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceFilterPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    return new Promise((resolve, reject) =>
                    {
                        const
                            entitySearch = entityCommandInformation.caller.get();

                        if (!entitySearch.processInstanceFilterParameterDialog)
                            entitySearch.processInstanceFilterParameterDialog = new ProcessInstanceFilterParameterDialog();

                        (entitySearch.processInstanceFilterParameterDialog as ProcessInstanceFilterParameterDialog)
                            .openAsync()
                            .then(result =>
                            {
                                if (result.dialogResult !== DialogResultEnum.ok)
                                    return;

                                entitySearch.currentFilter = result.promiseData;
                                resolve(undefined);
                            })
                            .catch(error =>
                            {
                                reject(error);
                            });
                    });
                })
        );
    }

    // #endregion

    // #endregion
}

